/* eslint-disable max-len */
export default {
  empty: '',
  messageType: {
    SMS: 'SMS',
    LMS: 'LMS',
    MMS: 'MMS',
    FRIENDTALK_TEXT: 'Brand Message (Freeform) Text',
    FRIENDTALK_IMAGE: 'Brand Message (Freeform) image',
    FRIENDTALK_WIDE_IMAGE: 'Brand Message (Freeform) Wide Image',
    FRIENDTALK_WIDE_ITEM_LIST: 'Brand Message (Freeform) Wide Item List',
    FRIENDTALK_COMMERCE: 'Brand Message (Freeform) Commerce',
    FRIENDTALK_CAROUSEL_FEED: 'Brand Message (Freeform) Carousel Feed',
    FRIENDTALK_CAROUSEL_COMMERCE: 'Brand Message (Freeform) Carousel Commerce',
    FRIENDTALK_PREMIUM_VIDEO: 'Brand Message (Freeform) Premium Video',
    ALIMTALK_BA: 'Notification Talk Basic Type',
    ALIMTALK_EX: 'Notification Talk Additional Information Type',
    ALIMTALK_AD: 'Add notification Talk Channel',
    ALIMTALK_MI: 'Notification Talk Complex',
    BRANDTALK_TEXT: 'Brand Text',
    BRANDTALK_IMAGE: 'Brand Image',
    BRANDTALK_WIDE_IMAGE: 'Brand Wide Image',
    BRANDTALK_WIDE_ITEM_LIST: 'Brand Wide Item List',
    BRANDTALK_CAROUSEL_FEED: 'Brand Carousel Feed',
    BRANDTALK_CAROUSEL_COMMERCE: 'Brand Carousel Commerce',
    BRANDTALK_COMMERCE: 'Brand Commerce',
    BRANDTALK_PREMIUM_VIDEO: 'Brand Premium Video',
  },
  newline: 'Line breaks: up to {count}',
  targetingType: {
    m: 'M: Advertiser’s Masudong users (Kakao opt-in)',
    n: 'N: Advertiser’s Masudong users (Kakao opt-in) - Channel friends',
    i: 'I: Advertiser’s request targets ∩ Channel friends',
  },
  imageType: {
    MMS_IMAGE: 'general image',
    NORMAL_IMAGE: 'General',
    WIDE_IMAGE: 'Wide',
    WIDE_ITEM_LIST_IMAGE: 'Wide Item List',
    MAIN_WIDE_ITEM_LIST_IMAGE: 'Main Wide Item List',
    CAROUSEL_FEED_IMAGE: 'Carousel Feed',
    CAROUSEL_COMMERCE_IMAGE: 'Carousel Commerce',
  },
  buttonType: {
    webLink: 'Web Link',
    appLink: 'app link',
    addChannel: 'Add Channel',
    businessForm: 'Business Form',
    businessFormOptions: {
      surveys: 'Take a survey in Talk',
      applications: 'Apply in Talk',
      reservations: 'Make a reservation in Talk',
    },
    botKeyword: 'Bot Keyword',
  },
  couponType: {
    numberDiscount: 'OO won discount coupon',
    percentDiscount: 'OO% discount coupon',
    deliveryDiscount: 'a discount coupon for shipping costs',
    freeCoupon: 'OO Free Coupons',
    upCoupon: 'OO UP coupon',
  },
  validation: {
    templateName: { alreadyUse: 'The template name is already in use.' },
    buttons: {
      list: { max: 'You can set no more than {count} buttons.' },
      couponLimit: 'With a coupon, you can set no more than {count} buttons. Please delete some buttons before proceeding.',
    },
    content: {
      max: 'The content must be 1,000 characters or fewer.',
      advertPhrase: 'Advertising messages must include \'(advertising)\' at the beginning of the message body.',
      arsNumber: 'Advertising messages must include the selected reject number in the message body.',
      required: 'The content is required.',
    },
    arsNumber: { required: 'A reject number is required.' },
    button: {
      androidDeepLink: {
        max: 'The Android app link must be 2,000 characters or fewer.',
        brandMax: 'The Android app link must be 1,000 characters or fewer.',
        required: 'An Android app link is required.',
        enabledVariable: 'The Android app link contains a variable that is not allowed.',
      },
      iosDeepLink: {
        max: 'The iOS app link must be 2,000 characters or fewer.',
        brandMax: 'The iOS app link must be 1,000 characters or fewer.',
        required: 'An iOS app link is required.',
        enabledVariable: 'The iOS app link contains a variable that is not allowed.',
      },
      mobileLink: {
        max: 'The mobile web link must be 2,000 characters or fewer.',
        brandMax: 'The mobile web link must be 1,000 characters or fewer.',
        required: 'A mobile web link is required.',
        laxUrl: 'The button mobile web link must be in URL format.',
        webLinkScheme: 'The mobile web link of a web link button must start with http:// or https:// (app scheme links are not allowed).',
        enabledVariable: 'The button mobile web link contains a variable that is not allowed.',
      },
      name: {
        dbmax: 'The entered button name exceeds the allowed maximum length.',
        max: {
          FRIENDTALK_TEXT: 'The button name must be 14 characters or fewer.',
          FRIENDTALK_IMAGE: 'The button name must be 14 characters or fewer.',
          FRIENDTALK_WIDE_IMAGE: 'The button name must be 8 characters or fewer.',
          FRIENDTALK_WIDE_ITEM_LIST: 'The button name must be 8 characters or fewer.',
          FRIENDTALK_COMMERCE: 'The button name must be 8 characters or fewer.',
          FRIENDTALK_CAROUSEL_FEED: 'The button name must be 8 characters or fewer.',
          FRIENDTALK_CAROUSEL_COMMERCE: 'The button name must be 8 characters or fewer.',
          FRIENDTALK_PREMIUM_VIDEO: 'The button name must be 8 characters or fewer.',

          BRANDTALK_TEXT: 'The button name must be 14 characters or fewer.',
          BRANDTALK_IMAGE: 'The button name must be 14 characters or fewer.',
          BRANDTALK_WIDE_IMAGE: 'The button name must be 8 characters or fewer.',
          BRANDTALK_WIDE_ITEM_LIST: 'The button name must be 8 characters or fewer.',
          BRANDTALK_COMMERCE: 'The button name must be 8 characters or fewer.',
          BRANDTALK_CAROUSEL_FEED: 'The button name must be 8 characters or fewer.',
          BRANDTALK_CAROUSEL_COMMERCE: 'The button name must be 8 characters or fewer.',
          BRANDTALK_PREMIUM_VIDEO: 'The button name must be 8 characters or fewer.',
        },
        required: 'The button name is required.',
        disallowedVariable: '버Variables cannot be used in the button name.',
        businessForm: 'The business form button name can only be entered as \'Take a survey in Talk\', \'Apply in Talk\', or \'Make a reservation in Talk\'.',
        disallowedUrlLink: 'The button name cannot contain a URL format.',
        enabledVariable: 'The button name contains a variable that is not allowed.',
      },
      pcLink: {
        max: 'The PC web link must be 2,000 characters or fewer.',
        brandMax: 'The PC web link must be 1,000 characters or fewer.',
        laxUrl: 'The button PC link must be in URL format.',
        webLinkScheme: 'The PC link of a web link button must start with http:// or https:// (app scheme links are not allowed).',
        variableFormat: 'Invalid variable format.',
        enabledVariable: 'The button PC link contains a variable that is not allowed.',
      },
      type: {
        allowedType: 'This is an unsupported button type.',
        businessFormEnded: 'Business Form (BF) buttons are no longer supported per Kakao policy. Please change to a different button type.',
        required: 'The button type is required.',
      },
      appLink: 'You must enter at least two links among Mobile Web, iOS App, and Android App.',
      bizFormKey: {
        required: 'Business ID is required.',
        disallowedVariable: 'Variables cannot be used in the Business ID.',
        enabledVariable: 'The Business ID contains a variable that is not allowed.',
      },
      addChannel: {
        position: 'For the channel add type, if it is brand text or image, it must be registered as the first button; for other message types, it must be registered as the last button.',
        max: 'There must be only one channel add type.',
        targeting: 'The channel add button can only be used when targeting is M or N.',
      },
      businessForm: {
        position: 'The business form button can only be registered as the first button.',
      },
    },
    carouselTail: {
      androidDeepLink: {
        max: 'The Android app link must be 2,000 characters or fewer.',
        brandMax: 'The Android app link must be 1,000 characters or fewer.',
        disallowedVariable: 'Variables cannot be used in the Android app link.',
        enabledVariable: 'The Android app link contains a variable that is not allowed.',
      },
      iosDeepLink: {
        max: 'The iOS app link must be 2,000 characters or fewer.',
        brandMax: 'The iOS app link must be 1,000 characters or fewer.',
        disallowedVariable: 'Variables cannot be used in the iOS app link.',
        enabledVariable: 'The iOS app link contains a variable that is not allowed.',
      },
      mobileLink: {
        max: 'The mobile web link must be 2,000 characters or fewer.',
        brandMax: 'The mobile web link must be 1,000 characters or fewer.',
        required: 'The mobile web link are required.',
        url: 'The mobile web link must be in URL format.',
        disallowedVariable: 'Variables cannot be used in the mobile web link.',
        enabledVariable: 'The mobile web link contains a variable that is not allowed.',
      },
      pcLink: {
        max: 'The PC web link must be 2,000 characters or fewer.',
        brandMax: 'The PC web link must be 1,000 characters or fewer.',
        url: 'The PC web link must be in URL format.',
        disallowedVariable: 'Variables cannot be used in the PC web link.',
        enabledVariable: 'The PC web link contains a variable that is not allowed.',
      },
    },
    coupon: {
      description: {
        FRIENDTALK_TEXT: {
          max: 'The coupon description must be 12 characters or fewer.',
        },
        FRIENDTALK_IMAGE: {
          max: 'The coupon description must be 12 characters or fewer.',
        },
        FRIENDTALK_WIDE_IMAGE: {
          max: 'The coupon description must be 18 characters or fewer.',
        },
        FRIENDTALK_WIDE_ITEM_LIST: {
          max: 'The coupon description must be 18 characters or fewer.',
        },
        FRIENDTALK_COMMERCE: {
          max: 'The coupon description must be 12 characters or fewer.',
        },
        FRIENDTALK_CAROUSEL_FEED: {
          max: 'The coupon description must be 12 characters or fewer.',
        },
        FRIENDTALK_CAROUSEL_COMMERCE: {
          max: 'The coupon description must be 12 characters or fewer.',
        },
        FRIENDTALK_PREMIUM_VIDEO: {
          max: 'The coupon description must be 18 characters or fewer.',
        },
        BRANDTALK_TEXT: { max: 'The coupon description must be 12 characters or fewer.' },
        BRANDTALK_IMAGE: { max: 'The coupon description must be 12 characters or fewer.' },
        BRANDTALK_WIDE_IMAGE: { max: 'The coupon description must be 18 characters or fewer.' },
        BRANDTALK_WIDE_ITEM_LIST: { max: 'The coupon description must be 18 characters or fewer.' },
        BRANDTALK_COMMERCE: { max: 'The coupon description must be 12 characters or fewer.' },
        BRANDTALK_CAROUSEL_FEED: { max: 'The coupon description must be 12 characters or fewer.' },
        BRANDTALK_CAROUSEL_COMMERCE: { max: 'The coupon description must be 12 characters or fewer.' },
        BRANDTALK_PREMIUM_VIDEO: { max: 'The coupon description must be 18 characters or fewer.' },
        max: 'The coupon description must not exceed 50 characters.',
        required: 'The coupon description is required.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'The coupon description cannot contain a URL format.',
        enabledVariable: 'The coupon description contains a variable that is not allowed.',

      },
      iosDeepLink: {
        max: 'The iOS app link must be 2,000 characters or fewer.',
        brandMax: 'The iOS app link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
        enabledVariable: 'The iOS app link contains a variable that is not allowed.',
      },
      androidDeepLink: {
        max: 'The Android app link must be 2,000 characters or fewer.',
        brandMax: 'The Android app link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
        enabledVariable: 'The Android app link contains a variable that is not allowed.',
      },
      link: {
        required: 'For link parameters, one of the following conditions must be met:\n\nUse a mobile web link.\nUse a Kakao Channel coupon URL (format: alimtalk=coupon://) in either the Android or iOS link.',
      },
      mobileLink: {
        laxUrl: 'The mobile web link must be in URL format.',
        max: 'The mobile web link must be 2,000 characters or fewer.',
        url: 'The mobile web link must in URL format.',
        brandMax: 'The mobile web link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
        enabledVariable: 'The coupon mobile link contains a variable that is not allowed.',
      },
      name: {
        deliveryDiscount: { length: 'The coupon name must be empty.' },
        freeCoupon: {
          max: 'The coupon value must be 7 characters or fewer.',
          min: 'Please enter the coupon value.',
        },
        max: 'The coupon name must be 50 characters or fewer.',
        numberDiscount: {
          integer: 'The coupon value must be a number.',
          max: 'The coupon value must be 99,999,999 or fewer.',
          min: 'Please enter the coupon value.',
        },
        percentDiscount: {
          integer: 'The coupon value must be a number.',
          max: 'The coupon value must be 100 or fewer.',
          min: 'Please enter the coupon value.',
        },
        upCoupon: {
          max: 'The coupon name must be 7 characters or fewer.',
          min: 'Please enter the name of the coupon.',
        },
        enabledVariable: 'The coupon name contains a variable that is not allowed.',
      },
      pcLink: {
        max: 'The PC web link must be 2,000 characters or fewer.',
        url: 'The PC web link must in URL format.',
        brandMax: 'The PC web link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
        enabledVariable: 'The PC web link contains a variable that is not allowed.',
      },
      templateName: {
        required: 'The coupon template name is required.',
        max: 'The coupon template name must be 25 characters or fewer.',
      },
    },
    sms: {
      content: {
        max: 'The SMS content must be 120 characters or fewer.',
        required: 'The SMS content is required.',
        enabledVariable: 'The SMS content contains a variable that is not allowed.',
        disallowedEmoji: 'SMS content cannot use emojis.',
      },
    },
    lms: {
      subject: {
        max: 'The LMS title must be 120 characters or fewer.',
        required: 'The LMS title is required.',
        disallowedVariable: 'Variables cannot be used in the LMS title.',
        disallowedEmoji: 'LMS title cannot use emojis.',
      },
      content: {
        max: 'The LMS content must be 1,000 characters or fewer.',
        required: 'The LMS content is required.',
        enabledVariable: 'The LMS content contains a variable that is not allowed.',
        disallowedEmoji: 'LMS content cannot use emojis.',
      },
    },
    mms: {
      content: {
        max: 'The MMS content must be 1,000 characters or fewer.',
        required: 'The MMS content is required.',
        enabledVariable: 'The MMS content contains a variable that is not allowed.',
        disallowedEmoji: 'MMS content cannot use emojis.',
      },
      image: {
        imageId: 'The MMS image must be in UUID format.',
        required: 'The MMS image is required.',
      },
      subject: {
        disallowedVariable: 'Variables cannot be used in the MMS title.',
        max: 'The MMS title must be 120 characters or fewer.',
        required: 'The MMS title is required.',
        disallowedEmoji: 'MMS title cannot use emojis.',
      },
    },
    FRIENDTALK_TEXT: {
      buttons: {
        coupon: {
          maxFive: 'If a coupon is included, no more than 4 buttons can be used.',
        },
        maxLength: 'A maximum of 5 buttons can be added.',
      },
      coupon: { maxLength: 'A maximum of one coupon can be added.' },
      content: {
        dbmax: 'The entered content exceeds the allowed maximum length.',
        max: 'The content must be 1,300 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to 99 times.',
        required: 'The content is required.',
        enabledVariable: 'The content contains a variable that is not allowed.',
      },
    },
    FRIENDTALK_IMAGE: {
      buttons: {
        coupon: {
          maxFive: 'If a coupon is included, no more than 4 buttons can be used.',
        },
        maxLength: 'A maximum of 5 buttons can be added.',
      },
      coupon: { maxLength: 'A maximum of one coupon can be added.' },
      content: {
        required: 'The content is required.',
        dbmax: 'The entered content exceeds the allowed maximum length.',
        max: 'The content must be 1,300 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to 99 times.',
        enabledVariable: 'The content contains a variable that is not allowed.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      imageLink: {
        max: 'The image link must be 2,000 characters or fewer.',
        brandMax: 'The image link must be 1,000 characters or fewer.',
        laxUrl: 'The image link must be in URL format.',
        enabledVariable: 'The image link contains a variable that is not allowed.',
      },
    },
    FRIENDTALK_WIDE_IMAGE: {
      buttons: { maxLength: 'A maximum of two buttons can be added.' },
      coupon: { maxLength: 'A maximum of one coupon can be added.' },
      content: {
        required: 'The content is required.',
        dbmax: 'The entered content exceeds the allowed maximum length.',
        max: 'The content must be 76 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to 5 times.',
        enabledVariable: 'The content contains a variable that is not allowed.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      imageLink: {
        max: 'The image link must be 2,000 characters or fewer.',
        brandMax: 'The image link must be 1,000 characters or fewer.',
        laxUrl: 'The image link must be in URL format.',
        enabledVariable: 'The image link contains a variable that is not allowed.',
      },
    },
    FRIENDTALK_WIDE_ITEM_LIST: {
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      header: {
        dbmax: 'The entered main item title exceeds the allowed maximum length.',
        max: 'The main item title must be 20 characters or fewer.',
        maxLine: 'Line breaks are not allowed in the main item title.',
        required: 'The main item title is required.',
        enabledVariable: 'The main item title contains a variable that is not allowed.',
        disallowedUrlLink: 'The main item title cannot contain a URL format.',
      },
      content: {
        firstMax: 'The main item content must be 25 characters or fewer.',
        max: 'The content must be 30 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to once.',
        required: 'The content is required.',
        enabledVariable: 'The content contains a variable that is not allowed.',
        disallowedUrlLink: 'Item content cannot contain a URL format.',
      },
      mobileLink: {
        laxUrl: 'The mobile web link must be in URL format.',
        max: 'The mobile web link must be 2,000 characters or fewer.',
        brandMax: 'The mobile web link must be 1,000 characters or fewer.',
        required: 'The mobile web link is required.',
        enabledVariable: 'The mobile web link contains a variable that is not allowed.',
      },
      pcLink: {
        laxUrl: 'The PC web link must be in URL format.',
        max: 'The PC web link must be 2,000 characters or fewer.',
        brandMax: 'The PC web link must be 1,000 characters or fewer.',
        enabledVariable: 'The PC web link contains a variable that is not allowed.',
      },
      androidDeepLink: {
        max: 'The Android app link must be 2,000 characters or fewer.',
        brandMax: 'The Android app link must be 1,000 characters or fewer.',
        enabledVariable: 'The Android app link contains a variable that is not allowed.',
      },
      iosDeepLink: {
        max: 'The iOS app link must be 2,000 characters or fewer.',
        brandMax: 'The iOS app link must be 1,000 characters or fewer.',
        enabledVariable: 'The iOS app link contains a variable that is not allowed.',
      },
      buttons: { maxLength: 'A maximum of two buttons can be added.' },
      coupon: { maxLength: 'A maximum of one coupon can be added.' },
      list: {
        max: 'A maximum of two items can be added.',
        min: 'At least 3 items are required.',
      },
    },
    FRIENDTALK_COMMERCE: {
      buttons: {
        maxLength: 'A maximum of two buttons can be added.',
        minLength: 'At least 1 button is required.',
      },
      coupon: { maxLength: 'A maximum of one coupon can be added.' },
      additionalContent: {
        dbmax: 'The entered additional information exceeds the allowed maximum length.',
        max: 'The additional information must be 34 characters or fewer.',
        enabledVariable: 'The additional information contains a variable that is not allowed.',
        maxLine: 'Line breaks in additional information are allowed up to once.',
        disallowedUrlLink: 'Additional information cannot contain a URL format.',
      },
      discountFixed: {
        dbmax: 'The entered fixed discount price exceeds the allowed maximum length.',
        integer: 'The fixed discount price must be a number.',
        max: 'The fixed discount price must be 999,999 or less.',
        min: 'The fixed discount price must be 0 or greater.',
        positive: 'The fixed discount price must be a number.',
        required: 'The fixed discount price is required.',
        enabledVariable: 'The fixed discount price contains a variable that is not allowed.',
      },
      discountPrice: {
        dbmax: 'The entered discount price exceeds the allowed maximum length.',
        integer: 'The discount price must be a number.',
        max: 'The discount price must be 999,999 or less.',
        min: 'The discount price must be 0 or greater.',
        positive: 'The discount price must be a number.',
        required: 'The discount price is required.',
        enabledVariable: 'The discount price contains a variable that is not allowed.',
      },
      discountRate: {
        dbmax: 'The entered discount rate exceeds the allowed maximum length.',
        integer: 'The discount rate must be a number.',
        max: 'The discount rate must be 100 or less.',
        min: 'The discount rate must be 0 or greater.',
        positive: 'The discount rate must be a number.',
        required: 'The discount price is required.',
        enabledVariable: 'The discount rate contains a variable that is not allowed.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      imageLink: {
        laxUrl: 'The image link must be in URL format.',
        max: 'The image link must be 2,000 characters or fewer.',
        brandMax: 'The image link must be 1,000 characters or fewer.',
        enabledVariable: 'The image link contains a variable that is not allowed.',
      },
      regularPrice: {
        dbmax: 'The entered regular price exceeds the allowed maximum length.',
        integer: 'The regular price must be a number.',
        max: 'The regular price must be 999,999 or less.',
        min: 'The regular price must be 0 or greater.',
        positive: 'The regular price must be a number.',
        required: 'The regular price is required.',
        enabledVariable: 'The regular price contains a variable that is not allowed.',
      },
      title: {
        dbmax: 'The entered product name exceeds the allowed maximum length.',
        max: 'The product name must be 30 characters or fewer.',
        required: 'The product name is required.',
        enabledVariable: 'The product name contains a variable that is not allowed.',
        maxLine: 'Line breaks are not allowed in the product name.',
        disallowedUrlLink: 'The product name cannot contain a URL format.',
      },
      commerce: 'When entering a discount price, either the discount rate or the fixed discount price must be provided.',
      brandCommerce: '\'discountRate\' and \'discountFixed\' cannot be used together. Only one of these variables should be provided.',
    },
    FRIENDTALK_CAROUSEL_FEED: {
      buttons: {
        maxLength: 'A maximum of two buttons can be added.',
        minLength: 'At least 1 button is required.',
      },
      coupon: { maxLength: 'A maximum of two buttons can be added.' },
      content: {
        dbmax: 'The entered content exceeds the allowed maximum length.',
        max: 'The content must be 180 characters or fewer.',
        required: 'The content is required.',
        enabledVariable: 'The content contains a variable that is not allowed.',
      },
      header: {
        dbmax: 'The entered title exceeds the allowed maximum length.',
        max: 'The title must be 20 characters or fewer.',
        required: 'The title is required.',
        enabledVariable: 'The title contains a variable that is not allowed.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      imageLink: {
        laxUrl: 'The image link must in URL format.',
        max: 'The image link must be 2,000 characters or fewer.',
        brandMax: 'The image link must be 1,000 characters or fewer.',
      },
      list: {
        max: 'A maximum of 10 carousels can be added.',
        min: 'At least two carousels are required.',
      },
    },
    FRIENDTALK_CAROUSEL_COMMERCE: {
      buttons: {
        maxLength: 'A maximum of two buttons can be used.',
        minLength: 'At least 1 button is required.',
      },
      coupon: { maxLength: 'A maximum of one coupon can be added.' },
      androidDeepLink: {
        max: 'The intro Android app link must be 2,000 characters or fewer.',
        brandMax: 'The intro Android app link must be 1,000 characters or fewer.',
        enabledVariable: 'The intro Android app link contains a variable that is not allowed.',
      },
      content: {
        dbmax: 'The entered intro content exceeds the allowed maximum length.',
        max: 'The intro content must be 50 characters or fewer.',
        required: 'The intro content is required.',
        enabledVariable: 'The intro content contains a variable that is not allowed.',
        maxLine: 'Line breaks in intro content are allowed up to 2 times.',
        disallowedUrlLink: 'The intro content cannot contain a URL format.',
      },
      discountFixed: {
        integer: 'The fixed discount price must be a number.',
        max: 'The fixed discount price must be 999,999 or less.',
        min: 'The fixed discount price must be 0 or greater.',
        positive: 'The fixed discount price must be a number.',
        enabledVariable: 'The fixed discount price contains a variable that is not allowed.',
      },
      discountPrice: {
        integer: 'The discount price must be a number.',
        max: 'The discount price must be 999,999 or less.',
        min: 'The discount price must be 0 or greater.',
        positive: 'The discount price must be a number.',
        enabledVariable: 'The discount price contains a variable that is not allowed.',
      },
      discountRate: {
        integer: 'The discount rate must be a number.',
        max: 'The discount rate must be 100 or less.',
        min: 'The discount rate must be 0 or greater.',
        positive: 'The discount rate must be a number.',
        enabledVariable: 'The discount rate contains a variable that is not allowed.',
      },
      header: {
        dbmax: 'The entered intro title exceeds the allowed maximum length.',
        max: 'The intro title must be 20 characters or fewer.',
        required: 'The intro title is required.',
        enabledVariable: 'The intro title contains a variable that is not allowed.',
        disallowedUrlLink: 'The intro title cannot contain a URL format.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        ratio: 'The image\'s width-to-height ratio must be consistent.',
        required: 'An image is required.',
      },
      introImage: {
        imageId: 'The intro image ID must be in UUID format.',
        ratio: 'The intro image\'s width-to-height ratio must be consistent.',
        required: 'The intro image is required.',
      },
      iosDeepLink: {
        max: 'The intro iOS app link must be 2,000 characters or fewer.',
        brandMax: 'The intro iOS app link must be 1,000 characters or fewer.',
        enabledVariable: 'The intro iOS app link contains a variable that is not allowed.',
      },
      list: {
        length: {
          max: 'A maximum of 10 carousels can be added.',
          min: 'At least two carousels are required.',
        },
      },
      mobileLink: {
        required: 'The intro mobile link is required when any intro link is used.',
        laxUrl: 'The intro mobile link must be in URL format.',
        max: 'The intro mobile link must be 2,000 characters or fewer.',
        brandMax: 'The intro mobile link must be 1,000 characters or fewer.',
        enabledVariable: 'The intro mobile link contains a variable that is not allowed.',
      },
      pcLink: {
        laxUrl: 'The intro PC link must be in URL format.',
        max: 'The intro PC link must be 2,000 characters or fewer.',
        brandMax: 'The intro PC link must be 1,000 characters or fewer.',
        enabledVariable: 'The intro PC link contains a variable that is not allowed.',
      },
      regularPrice: {
        integer: 'The regular price must be a number.',
        max: 'The regular price must be 999,999 or less.',
        min: 'The regular price must be 0 or greater.',
        positive: 'The regular price must be a number.',
        required: 'The regular price is required.',
        enabledVariable: 'The regular price contains a variable that is not allowed.',
      },
      title: {
        max: 'The product name must be 30 characters or fewer.',
        required: 'The product name is required.',
        enabledVariable: 'The product name contains a variable that is not allowed.',
        maxLine: 'Line breaks are not allowed in the product name.',
        disallowedUrlLink: 'The product name cannot contain a URL format.',
      },
      commerce: 'When entering a discount price, either the discount rate or the fixed discount price must be provided.',
      brandCommerce: '\'discountRate\' and \'discountFixed\' cannot be used together. Only one of these variables should be provided.',
      imageLink: {
        laxUrl: 'The image link must be in URL format.',
        max: 'The image link must be 2,000 characters or fewer.',
        brandMax: 'The image link must be 1,000 characters or fewer.',
        enabledVariable: 'The image link contains a variable that is not allowed.',
      },
      additionalContent: {
        dbmax: 'The entered additional information exceeds the allowed maximum length.',
        max: 'The additional information must be 34 characters or fewer.',
        enabledVariable: 'The additional information contains a variable that is not allowed.',
        maxLine: 'Line breaks in additional information are allowed up to once.',
        disallowedUrlLink: 'Additional information cannot contain a URL format.',
      },
    },
    FRIENDTALK_PREMIUM_VIDEO: {
      buttons: { maxLength: 'A maximum of one button can be added.' },
      coupon: { maxLength: 'A maximum of one coupon can be added.' },
      content: {
        dbmax: 'The entered content exceeds the allowed maximum length.',
        max: 'The content must be 76 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to 5 times.',
        enabledVariable: 'The content contains a variable that is not allowed.',
      },
      header: {
        dbmax: 'The entered title exceeds the allowed maximum length.',
        max: 'The title must be 20 characters or fewer.',
        enabledVariable: 'The title contains a variable that is not allowed.',
      },
      image: { imageId: 'The thumbnail image ID must be in UUID format.' },
      video: {
        max: 'The image link must be 500 characters or fewer.',
        required: 'The image link must in URL format.',
        url: 'The video URL must be in the format https://tv.kakao.com/v/#{number} or https://tv.kakao.com/channel/#{number}/cliplink/#{number}.',
      },
    },
    image: {
      sms: {
        size: 'The MMS image must be 100 KB or less.',
        extension: 'The MMS images only support jpg or jpeg formats.',
      },
      carouselCommerce: {
        extension: 'Only .jpg and .png image formats are supported.',
        height: { max: 'The image height must be 4,500px or less.' },
        ratio: {
          max: 'The imag\'s width-to-height ratio must be at least 2:1 and no more than 3:4.',
          min: 'The imag\'s width-to-height ratio must be at least 2:1 and no more than 3:4.',
        },
        size: 'The image must be 5 MB or less.',
        width: {
          max: 'The image width must be 4,500px or less.',
          min: 'The image width must be at least 500px.',
        },
      },
      carouselFeed: {
        extension: 'The image only support .jpg or .png formats.',
        height: { max: 'The image height must be 4,500px or less.' },
        ratio: {
          max: 'The image\'s width-to-height ratio must be at least 2:1 and no more than 3:4.',
          min: 'The image\'s width-to-height ratio must be at least 2:1 and no more than 3:4.',
        },
        size: 'The image must be 5 MB or less.',
        width: {
          max: 'The image width must be 4,500px or less.',
          min: 'The image width must be at least 500px.',
        },
      },
      normal: {
        extension: 'The image only support .jpg or .png formats.',
        height: {
          max: 'The image height must be 4,500px or less.',
          min: 'The image height must be at least 250px.',
        },
        ratio: {
          max: 'The image\'s width-to-height ratio must be at least 2:1 and no more than 3:4.',
          min: 'The image\'s width-to-height ratio must be at least 2:1 and no more than 3:4.',
        },
        size: 'The image must be 5 MB or less.',
        width: {
          max: 'The image width must be 4,500px or less.',
          min: 'The image width must be at least 500px.',
        },
      },
      wide: {
        extension: 'The image only support .jpg or .png formats.',
        size: 'The image must be 5 MB or less.',
        widthHeight: 'The image width must be 800px, and the height must be 600px.',
      },
      wideItemList: {
        extension: 'The image only support .jpg or .png formats.',
        height: {
          min: 'The image height must be 400px.',
          max: 'The image height must be 4500px.',
        },
        size: 'The image must be 5 MB or less.',
        width: {
          min: 'The image width must be at least 500px.',
          max: 'The image width must be 4500px or less.',
        },
        ratio: '이미지의 가로 : 세로 비율은 1:1 혹은 2:1 이어야 합니다.',
      },
      file: { required: 'An image is required.' },
      imageName: {
        required: 'The image name is required.',
        max: 'The image name must be 25 characters or fewer.',
      },
      extension: 'This file format is not supported.',
    },
    kakaoProfile: {
      required: 'The Kakao profile is required.',
      uuid: 'The Kakao profile must be in UUID format.',
    },
    outgoingPhone: { required: 'A sender number is required.' },
    personalizationFields: { required: 'Customer settings are required.' },
    preTemplateId: { required: 'The template ID is required.' },
    preTemplates: {
      templateName: {
        max: 'The template name must be 25 characters or fewer.',
        required: 'The template name is required.',
      },
    },
    recipientNumber: {
      required: 'A receipt number is required.',
      enabledVariable: 'You have selected a sender number that is not allowed. Please select a different number.',
      variable: 'You need to select a valid field for the recipient number. Please choose again.',
    },
    rejectPhone: { required: 'An opt-out number is required.' },
    subject: {
      max: 'The content must be 30 characters or fewer.',
    },
    friendtalkCommerce: {
      commerce: 'When entering a discount price, either the discount rate or the fixed discount price must be provided.',
    },
    additionalFields: {
      required: 'The additional information is required.',
      max: 'The additional information must be 100 characters or fewer.',
      maxLength: 'A maximum of 10 additional information items can be added.',
      enabledVariable: 'The additional information contains a variable that is not allowed.',
    },
    targetingSettings: {
      required: 'Targeting settings are required.',
      type: 'This is not an allowed targeting setting type.',
    },
    BRANDTALK_TEXT: {
      buttons: {
        coupon: { maxFive: 'If a coupon is included, only up to 4 buttons can be added.' },
        maxLength: 'Up to 5 buttons can be added.',
      },
      coupon: { maxLength: 'Only 1 coupon can be added.' },
      content: {
        required: 'Content is required.',
        max: 'Content must be 1,300 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to 99 times.',
        variableFormat: 'Invalid variable format.',
      },
    },
    BRANDTALK_IMAGE: {
      buttons: {
        coupon: { maxFive: 'If a coupon is included, only up to 4 buttons can be added.' },
        maxLength: 'Up to 5 buttons can be added.',
      },
      coupon: { maxLength: 'Only 1 coupon can be added.' },
      content: {
        required: 'Content is required.',
        max: 'Content must be 400 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to 29 times.',
        variableFormat: 'Invalid variable format.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      imageLink: {
        max: 'The image link must be 1,000 characters or fewer.',
        laxUrl: 'The image link must be in URL format.',
        disallowedVariable: 'Variables cannot be used in the image link.',
      },
    },
    BRANDTALK_WIDE_IMAGE: {
      buttons: { maxLength: 'Up to 2 buttons can be added.' },
      coupon: { maxLength: 'Only 1 coupon can be added.' },
      content: {
        required: 'Content is required.',
        max: 'Content must be 76 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to once.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'Content cannot contain a URL format.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      imageLink: {
        max: 'The image link must be 1,000 characters or fewer.',
        laxUrl: 'The image link must be in URL format.',
        disallowedVariable: 'Variables cannot be used in the image link.',
      },
    },
    BRANDTALK_WIDE_ITEM_LIST: {
      buttons: { maxLength: 'Up to 2 buttons can be added.' },
      coupon: { maxLength: 'Only 1 coupon can be added.' },
      header: {
        required: 'The main item title is required.',
        max: 'The main item title must be 20 characters or fewer.',
        maxLine: 'Line breaks are not allowed in the main item title.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'The main item title cannot contain a URL format.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      content: {
        required: 'Content is required.',
        firstMax: 'The main item content must be 25 characters or fewer.',
        max: 'Content must be 30 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to once.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'Item content cannot contain a URL format.',
      },
      mobileLink: {
        required: 'The mobile web link is required.',
        max: 'The mobile web link must be 1,000 characters or fewer.',
        laxUrl: 'The mobile web link must be in URL format.',
        variableFormat: 'Invalid variable format.',
      },
      pcLink: {
        max: 'The PC web link must be 1,000 characters or fewer.',
        laxUrl: 'The PC web link must be in URL format.',
        variableFormat: 'Invalid variable format.',
      },
      androidDeepLink: {
        max: 'The Android app link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
      },
      iosDeepLink: {
        max: 'The iOS app link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
      },
      list: {
        max: 'Up to 4 items can be added.',
        min: 'At least 3 items are required.',
      },
    },
    BRANDTALK_COMMERCE: {
      buttons: {
        maxLength: 'Up to 2 buttons can be added.',
        minLength: 'At least 1 button is required.',
      },
      coupon: { maxLength: 'Only 1 coupon can be added.' },
      title: {
        required: 'The product name is required.',
        max: 'The product name must be 30 characters or fewer.',
        maxLine: 'Line breaks are not allowed in the product name.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'The product name cannot contain a URL format.',
      },
      regularPrice: {
        integer: 'The regular price must be a number.',
        max: 'The regular price must be 99,999,999 or less.',
        min: 'The regular price must be 0 or greater.',
        positive: 'The regular price must be a number.',
        required: 'The regular price is required.',
      },
      discountPrice: {
        integer: 'The discount price must be a number.',
        max: 'The discount price must be 99,999,999 or less.',
        min: 'The discount price must be 0 or greater.',
        positive: 'The discount price must be a number.',
        required: 'The discount price is required.',
      },
      discountRate: {
        integer: 'The discount rate must be a number.',
        max: 'The discount rate must be 100 or less.',
        min: 'The discount rate must be 0 or greater.',
        positive: 'The discount rate must be a number.',
        required: 'The discount rate is required.',
      },
      discountFixed: {
        integer: 'The fixed discount price must be a number.',
        max: 'The fixed discount price must be 999,999 or less.',
        min: 'The fixed discount price must be 0 or greater.',
        positive: 'The fixed discount price must be a number.',
        required: 'The fixed discount price is required.',
      },
      additionalContent: {
        variableFormat: 'Invalid variable format.',
        max: 'Additional information must be 34 characters or fewer.',
        maxLine: 'Line breaks in additional information are allowed up to once.',
        disallowedUrlLink: 'Additional information cannot contain a URL format.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      imageLink: {
        laxUrl: 'The image link must be in URL format.',
        max: 'The image link must be 1,000 characters or fewer.',
        disallowedVariable: 'Variables cannot be used in the image link.',
      },
      commerce: 'When entering a discount price, either the discount rate or the fixed discount price must be provided.',
      brandCommerce: '\'discountRate\' and \'discountFixed\' cannot be used together. Only one of these variables should be provided.',
    },
    BRANDTALK_CAROUSEL_FEED: {
      buttons: {
        maxLength: 'Up to 2 buttons can be added for carousel type.',
        minLength: 'At least 1 button is required for carousel type.',
      },
      coupon: { maxLength: 'Only 1 coupon can be added.' },
      header: {
        required: 'The title is required.',
        max: 'The title must be 20 characters or fewer.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'The title cannot contain a URL format.',
      },
      content: {
        required: 'Content is required.',
        max: 'Content must be 180 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to 2 times.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'Content cannot contain a URL format.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        required: 'An image is required.',
      },
      imageLink: {
        laxUrl: 'The image link must be in URL format.',
        max: 'The image link must be 1,000 characters or fewer.',
        disallowedVariable: 'Variables cannot be used in the image link.',
      },
      list: {
        max: 'Up to 6 carousel items can be added.',
        min: 'At least 2 carousel items are required.',
      },
    },
    BRANDTALK_CAROUSEL_COMMERCE: {
      introImage: {
        imageId: 'The intro image ID must be in UUID format.',
        ratio: 'The intro image width-to-height ratio must be consistent.',
        required: 'The intro image is required.',
      },
      header: {
        max: 'The intro title must be 20 characters or fewer.',
        required: 'The intro title is required.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'The intro title cannot contain a URL format.',
      },
      content: {
        max: 'The intro content must be 50 characters or fewer.',
        required: 'The intro content is required.',
        maxLine: 'Line breaks in intro content are allowed up to 2 times.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'The intro content cannot contain a URL format.',
      },
      mobileLink: {
        laxUrl: 'The intro mobile link must be in URL format.',
        max: 'The intro mobile link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
      },
      pcLink: {
        laxUrl: 'The intro PC link must be in URL format.',
        max: 'The intro PC link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
      },
      iosDeepLink: {
        max: 'The intro iOS app link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
      },
      androidDeepLink: {
        max: 'The intro Android app link must be 1,000 characters or fewer.',
        variableFormat: 'Invalid variable format.',
      },
      image: {
        imageId: 'The image ID must be in UUID format.',
        ratio: 'The image width-to-height ratio must be consistent.',
        required: 'An image is required.',
      },
      additionalContent: {
        max: 'Additional information must be 34 characters or fewer.',
        maxLine: 'Line breaks in additional information are allowed up to once.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'Additional information cannot contain a URL format.',
      },
      buttons: {
        maxLength: 'Up to 2 buttons can be added for carousel type.',
        minLength: 'At least 1 button is required for carousel type.',
      },
      coupon: { maxLength: 'Only 1 coupon can be added.' },
      title: {
        required: 'The product name is required.',
        max: 'The product name must be 30 characters or fewer.',
        maxLine: 'Line breaks are not allowed in the product name.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'The product name cannot contain a URL format.',
      },
      regularPrice: {
        integer: 'The regular price must be a number.',
        max: 'The regular price must be 99,999,999 or less.',
        min: 'The regular price must be 0 or greater.',
        positive: 'The regular price must be a number.',
        required: 'The regular price is required.',
      },
      discountPrice: {
        integer: 'The discount price must be a number.',
        max: 'The discount price must be 99,999,999 or less.',
        min: 'The discount price must be 0 or greater.',
        positive: 'The discount price must be a number.',
      },
      discountRate: {
        integer: 'The discount rate must be a number.',
        max: 'The discount rate must be 100 or less.',
        min: 'The discount rate must be 0 or greater.',
        positive: 'The discount rate must be a number.',
      },
      discountFixed: {
        integer: 'The fixed discount price must be a number.',
        max: 'The fixed discount price must be 999,999 or less.',
        min: 'The fixed discount price must be 0 or greater.',
        positive: 'The fixed discount price must be a number.',
      },
      list: {
        length: {
          max: 'Up to 6 carousel items can be added.',
          min: 'At least 2 carousel items are required.',
        },
      },
      commerce: 'When entering a discount price, either the discount rate or the fixed discount price must be provided.',
      brandCommerce: '\'discountRate\' and \'discountFixed\' cannot be used together. Only one of these variables should be provided.',
      imageLink: {
        laxUrl: 'The image link must be in URL format.',
        max: 'The image link must be 1,000 characters or fewer.',
        disallowedVariable: 'Variables cannot be used in the Business ID.',
      },
    },
    BRANDTALK_PREMIUM_VIDEO: {
      buttons: { maxLength: 'Up to 1 button can be added.' },
      coupon: { maxLength: 'Only 1 coupon can be added.' },
      image: { imageId: 'The thumbnail image ID must be in UUID format.' },
      header: {
        max: 'The title must be 20 characters or fewer.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'The title cannot contain a URL format.',
      },
      content: {
        max: 'Content must be 76 characters or fewer.',
        maxLine: 'Line breaks in content are allowed up to once.',
        variableFormat: 'Invalid variable format.',
        disallowedUrlLink: 'Content cannot contain a URL format.',
      },
      video: {
        max: 'The video URL must be 500 characters or fewer.',
        required: 'The video URL is required.',
        url: 'The video URL must be in the format https://tv.kakao.com/v/#{number} or https://tv.kakao.com/channel/#{number}/cliplink/#{number}.',
        disallowedVariable: 'Variables cannot be used in the video URL.',
      },
    },
    brandImage: {
      extension: 'Only .jpg or .png images are supported.',
      unsupportedExtension: 'This file type is not supported.',
      size: 'The image size must be 5MB or less.',
      normal: {
        width: {
          min: 'The image width must be at least 500px.',
          max: 'The image width must be 4,500px or less.',
        },
        height: {
          min: 'The image height must be at least 250px.',
          max: 'The image height must be 4,500px or less.',
        },
        ratio: 'The image width-to-height ratio must be between 2:1 and 3:4.',
      },
      wide: {
        width: {
          min: 'The image width must be at least 500px.',
          max: 'The image width must be 4,500px or less.',
        },
        height: {
          min: 'The image height must be at least 250px.',
          max: 'The image height must be 4,500px or less.',
        },
        ratio: 'The image width-to-height ratio must be between 2:1 and 1:1.',
      },
      mainWideItemList: {
        width: {
          min: 'The image width must be at least 500px.',
          max: 'The image width must be 4,500px or less.',
        },
        height: {
          min: 'The image height must be at least 250px.',
          max: 'The image height must be 4,500px or less.',
        },
        ratio: 'The image width-to-height ratio must be 2:1.',
      },
      wideItemList: {
        width: {
          min: 'The image width must be at least 500px.',
          max: 'The image width must be 4,500px or less.',
        },
        height: {
          min: 'The image height must be at least 500px.',
          max: 'The image height must be 4,500px or less.',
        },
        ratio: 'The image width-to-height ratio must be 1:1.',
      },
      carouselFeed: {
        width: {
          min: 'The image width must be at least 500px.',
          max: 'The image width must be 4,500px or less.',
        },
        height: {
          min: 'The image height must be at least 250px.',
          max: 'The image height must be 4,500px or less.',
        },
        ratio: 'The image width-to-height ratio must be between 2:1 and 3:4.',
      },
      carouselCommerce: {
        width: {
          min: 'The image width must be at least 500px.',
          max: 'The image width must be 4,500px or less.',
        },
        height: {
          min: 'The image height must be at least 250px.',
          max: 'The image height must be 4,500px or less.',
        },
        ratio: 'The image width-to-height ratio must be between 2:1 and 3:4.',
      },
    },
    emoji: {
      subjectAndContent: 'Unacceptable characters in title and body.',
    },
  },
  navigation: {
    mainTitle: 'Text/Kakao',
    subTitle: 'Message',
    message: 'TextMessage',
    friendtalk: 'Brand\nMessage\n(Freeform)',
    alimtalk: 'AlimTalk',
    brand: 'Brand\n Message',
    shippingResult: 'Sending Results',
    reserve: 'Scheduled',
    language: {
      select: 'Select Language',
      korean: 'Korean',
      english: 'English',
    },
  },
  preview: {
    title: 'PREVIEW',
    fallback: 'Fallback Sending',
    content: 'Please enter the contents.',
    brandMessageInfo: [
      'Messages will be sent upon agreeing to receive advertising information from this channel provider,',
      'and data charges may apply when using mobile data.',
      'If you do not wish to receive them, please click here to block the channel.',
    ],
  },
  button: {
    reset: 'Clear Content',
    messageLoad: 'Templates',
    attachImage: 'Attach Image',
    imageLoad: 'Images',
    imageUpload: 'Register',
    regist: 'Register',
    add: 'Add',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    fileUpload: 'Upload File',
    imageRegist: 'Register Image',
    templateRegist: 'Register Template',
    send: 'Enabled',
    notSend: 'Disabled',
    use: 'Enabled',
    notUse: 'Disabled',
    buttonSetting: 'Button Settings',
    couponLoad: 'Select Coupon',
    tailSetting: 'More View Settings',
    new: 'New',
    select: 'Select',
    viewDetails: 'Details',
    preview: 'Preview',
    exit: 'close',
    save: 'save',
    duplicate: 'Create a copy',
    previewOpen: 'Open preview',
    previewClose: 'Close preview',
  },
  title: {
    templateList: 'Template List',
    templateRegist: 'Register Template',
    imageList: 'Image List',
    imageRegist: 'Register Image',
    shippingResult: 'Sending Result',
    fallbackSetting: 'Fallback Sending Settings',
    buttonSetting: 'Button Settings',
    couponSetting: 'Coupon Settings',
    couponRegist: 'Register Coupon',
    couponList: 'Coupon List',
    tailSetting: 'More View Settings',
    templatePreview: 'Preview Template',
    additionalFields: 'Add Result File Contents',
  },
  label: {
    type: 'Type',
    types: 'Types',
    templateName: 'Template Name',
    required: 'Required',
    optional: 'Select',
    advert: 'Is Advertising',
    send: 'Enabled',
    notSend: 'Disabled',
    imageName: 'Image Name',
    attachImage: 'Attach Image',
    mobileWebLink: 'Mobile Web Links',
    pcWebLink: 'PC Web Links',
    iosDeepLink: 'iOS App Link',
    androidDeepLink: 'Android App Link',
    buttonType: 'Button Type',
    couponType: 'Coupon type',
    couponName: 'Coupon name',
    couponValue: 'Coupon Value',
    couponDescription: 'Coupon Description',
    addVariable: 'Add Variables',
    checkVariable: 'Check stored variable values',
    kakaoProfile: 'Kakao profile',
    recipientNumber: 'Receipt number',
    rejectPhone: 'Opt-out Number',
    customerSetting: 'Customer Settings',
    department: 'Department',
    messageSetting: 'Message Settings',
    nightSend: 'Nighttime Sending',
    outgoingPhone: 'Sender Number',
    fallback: 'Fallback Sending',
    messageType: 'Message Type',
    couponSetting: 'Coupon Settings',
    adultsMessages: 'Is Adults Message',
    redelivery: 'Next-day Sending option',
    buttonName: 'Button name',
    closeVariable: 'Close stored variable values',
    coupon: 'Coupon',
    informationalMessage: 'Informational Message',
    advertisingMessage: 'Advertising Message',
    tailSetting: 'More View Settings',
    isAdvertising: 'What is a Advertising Message?',
    resultInformation: 'Add Result File Contents',
    set: 'Enabled',
    notSet: 'Disabled',
    all: 'ALL',
    beforeTransmission: 'Before Sending Data',
    afterTransmission: 'After Sending Data',
    messageTypes: 'Message Type',
    imageTypes: 'Image Type',
    additionalFields: 'Additional information {count}',
    targetingSettings: 'Targeting Settings',
    isTargetingSettings: 'What is Targeting Settings?',
    template: 'Template',
    isPushNotification: 'Push Notification',
    buttonSetting: 'Button Settings',
    content: 'Content',
    businessFormType: 'Business Form Type',
    businessFormID: 'Business ID',
  },
  placeholder: {
    imageName: 'Image Name',
    templateName: 'Please enter the Title (up to 25 characters)',
    search: 'Search',
    character: 'Up to {count} characters',
    characters: 'You can enter up to {count} characters.',
    link: 'http://',
    link2: 'URL containing [http://, https://]',
    coupon: {
      NUMBER_DISCOUNT: 'You can enter more than 1 up to 99,999,999.',
      PERCENT_DISCOUNT: 'You can enter more than 1 and up to 100.',
      DELIVERY_DISCOUNT: '',
      FREE_COUPON: 'You can enter more than 1 up to 99,999,999.',
      UP_COUPON: 'You can enter up to 7 characters.',
    },
    button: 'Please enter a button.',
    char: 'characters',
    line: 'line',
  },
  tableHead: {
    type: 'Type',
    templateName: 'Template Name',
    createdDate: 'Create Date',
    journeyName: 'Journey Name',
    journeyVersion: 'Journey Version',
    activityName: 'Activity Name',
    messageType: 'Message Type',
    sendAllCnt: 'Targets',
    sendStart: 'Starts At',
    sendEnd: 'Ends At',
    successCnt: 'Success',
    imageSize: 'Size',
    couponName: 'Coupon name',
    couponDescription: 'Coupon Description',
    mobileWebLink: 'Mobile Web Links',
    tickets: 'Tickets',
  },
  comment: {
    variable: '※ Click where you want to insert, then click the variable button.',
    variable2: '※ Type # and choose a variable value.',
    noResult: 'No search results found.',
    nightSend: '※ Separate consent is required to send promotional messages at night.',
    noImage: 'There are no registered images.',
    redelivery: 'Message sending is restricted from 20:00 to 08:00. If next-day dispatch is selected, the message will be sent from 08:00 the next day. If not selected, the message will not be sent.',
    adultsMessages: 'Adult messages can only be applied when registering a brand message template.',
    variableMessage: 'This field supports variable names.',
    urlLinkMessage: 'This field supports URL format.',
    image: {
      kakaoExtension: 'Only JPG and PNG formats are supported.',
      kakaoCopyright: 'Unauthorized use of Kakao’s logo, trademarks, service names, or copyrighted materials, as well as guideline violations in informational (AlimTalk) or promotional (FriendTalk) messages, may result in service restrictions.',
      mms: {
        extension: 'Only JPG and PNG formats are supported.',
        limit: '100 KB or less',
      },
      kakaoBasic: {
        volume: '500 KB or less',
        wideVolume: '5MB or less',
        size: 'Minimum 500×250 px (width: length ratio greater than 2:1 and less than 3:4)',
        wideSize: 'The wide image should be 800px by 600px.',
        limit: 'When sending wide images, text message + link buttons (2) + images can be sent. Text message is limited to a maximum of 76 characters.',
      },
      wideItemList: {
        volume: '5MB or less',
        size: 'Width length 500px or more',
        crop: '이미지의 가로 : 세로 비율은 1:1 혹은 2:1 이어야 합니다.',
      },
      normal: {
        volume: '- Image size must be 500 KB or less for normal images.',
        size: '- Normal images must be at least 500px in width and at least 250px in length.',
      },
      carouselFeed: {
        volume: '5MB or less',
        size: 'Width length 500px or more (Wide: Length ratio greater than 2:1 and less than 3:4)',
      },
      carouselCommerce: {
        volume: '5MB or less',
        sameRatio: 'Images used to ship carousel commerce must all be in the same proportion',
        size: 'Width length 500px or more (Wide: Length ratio greater than 2:1 and less than 3:4)',
      },
      commerce: {
        size: '- Normal images must be at least 500px in width and at least 250px in length.',
      },
    },
    brandImage: {
      image: {
        volume: '5MB or less',
        recommendedSize: 'Recommended size: 800 x 400px (width at least 500px)',
        size: '- Minimum 500 x 250px (aspect ratio between 2:1 and 3:4)',
      },
      wide: {
        volume: '5MB or less',
        recommendedSize: 'Recommended size: 800 x 600px (width at least 500px)',
        size: '- Minimum 500 x 250px (aspect ratio between 2:1 and 3:4)',
      },
      mainWideItemList: {
        volume: '5MB or less',
        size: '- Minimum width: 500px',
        ratio: '- Aspect ratio: 2:1',
      },
      wideItemList: {
        volume: '5MB or less',
        size: '- Minimum width: 500px',
        ratio: '- Aspect ratio: 1:1',
      },
      carouselFeed: {
        volume: '5MB or less',
        recommendedSize: 'Recommended size: 800 x 600px or 800 x 400px (width at least 500px)',
        size: '- Minimum 500 x 250px (aspect ratio between 2:1 and 3:4)',
      },
      carouselCommerce: {
        volume: '5MB or less',
        recommendedSize: 'Recommended size: 800 x 600px or 800 x 400px (width at least 500px)',
        size: '- Minimum 500 x 250px (aspect ratio between 2:1 and 3:4)',
        sameRatio: 'All images used for carousel commerce must have the same aspect ratio.',
      },
      commerce: {
        volume: '5MB or less',
        recommendedSize: 'Recommended size: 800 x 400px (width at least 500px)',
        size: '- Minimum 500 x 250px (aspect ratio between 2:1 and 3:4)',
      },
    },
    selectPhoneNumber: 'Please select a phone number field.',
    resultInformation: '※ This information will not be sent to the customer and will be used for administrator records.',
    fallback: 'If you fail to send Kakao Talk, it will be sent by text message.',
    couponLink: [
      'For link parameters, one of the following two must be met.',
      '* Using a Mobile Web Link',
      '* Use the Kakao Channel Coupon URL (format: alimtalk=coupon://) for either Android or iOS link',
    ],
    alimtalk: [
      'AlimTalk\' is an',
      'informational message',
      'that can be sent even to users who have not added a KakaoTalk channel.',
    ],
    friendtalk: [
      'FriendTalk\' is a',
      'promotional message',
      'sent to users who have added a KakaoTalk channel.',
    ],
    carousel: [
      '※',
      'Up to 10',
      'carousels can be added.',
      'Up to 6',
    ],
    brandMessage: [
      'Brand messages ',
      'are restricted from being sent at night (8:00 PM ~ 8:00 AM).',
    ],
    brandVariable: [
      'Variable names must be used in the format #{variable}.',
      'Variables can include English, Korean, numbers, -, and _.',
      'When registering a template, variable names can be up to 20 characters long.',
      'Discount amount, discount rate, product name, regular price, discount price, and fixed discount price cannot be used as variables.',
    ],
  },
  alert: {
    notification: 'Notification',
    dataExtension: '{key} does not exist in DataExtension.',
    unauthorized: 'This is unauthorized information.',
    advert: {
      subject: 'Advertising Texting Guidance',
      content: `Advertising characters must include the uppermost '<span class="bold">(advertising)</span>' and <span class="bold"> name of sender, rejection number</span> in the text.
      Violation of this will result in a fine of up to 30 million won in accordance with Article 76 (1) 8 of the Information and Communication Network Act.
      Example)
      <span class="bold">(advertisement) Itumax</span>
      an advertising message
      <span class="bold">Reject free reception 0801234567</span>`,
    },
    deleteSelect: {
      subject: 'Notification',
      content: 'Please select the item you want to delete.',
    },
    advertGuide: {
      title: 'Informational/Advertising Message Guide',
      info: {
        title: 'What is an informational message?',
        content: 'A message corresponding to the "exception of commercial information for profit" in the Information and Communication Network Act guide',
        anchor: 'Spam Prevention Information and Communication Network Act Guide',
      },
      advert: {
        title: 'What is an advertising message?',
        subTitle: 'Messages sent by the sender for the purpose of economic gain',
        content: [
          'Information about the sender',
          'Information about goods or services to be provided by the sender',
        ],
      },
      requiredInclusions: {
        title: 'Mandatory Inclusion',
        content: [
          {
            title: 'Show Advertisement',
            content: 'The message title or content must appear at the beginning of the message title or content.',
          },
          {
            title: 'Show sender\'s contact information',
            content: 'The sender\'s name and contact number (telephone number or address) must be correctly identified.',
          },
          {
            title: 'Show how to reject reception',
            content: 'It should guide the recipient on how to make it easier to refuse reception and provide a free means of use.',
          },
        ],
      },
    },
    advertWarning: {
      title: 'Advertising Message Delivery Guide',
      caution: {
        title: 'Important Notice',
        content: [
          'Please make sure to include the following required notes when sending advertising text messages.',
          'In case of violation, a fine of not more than 30 million won will be imposed in accordance with Article 76 (1) 8 of the Information and Communication Network Act.',
        ],
      },
      requiredNotation: {
        title: 'Mandatory Notes',
        content: [
          'Mark \'(Ad)\' at the top of the character',
          '2. Name of sender',
          '3. Deny Receipt Number',
        ],
      },
      example: {
        title: 'Correct Example',
        content: [
          '(Advertising) i2max',
          'Advertising Message',
          'Free opt-out: 0801234567',
        ],
      },
    },
    targetingSettings: {
      title: 'Targeting Settings',
      img01: [
        'Client send',
        'Request target',
      ],
      img02: [
        'Channel friends',
        'Users',
      ],
      m: {
        title: 'Advertiser’s Masudong users (Kakao opt-in)',
        content: [
          'Advertising messages will be sent to the advertiser’s',
          'Masudong users who have opted in to Kakao.',
        ],
      },
      n: {
        title: 'Advertiser’s Masudong users (Kakao opt-in) - Channel friends',
        content: [
          'Advertising messages will be sent to the advertiser’s',
          'Masudong users with Kakao opt-in, excluding channel friends.',
        ],
      },
      i: {
        title: 'Advertiser’s request targets ∩ Channel friends',
        content: [
          'Advertising messages will be sent only if the advertiser’s',
          'request target is also a channel friend.',
        ],
      },
    },
    cautionTitle: 'Warning',
    removeButton: '"Do you want to delete the button?"',
    removeAdditionalField: '"Do you want to delete the additional information?"',
    removeCoupon: '"Do you want to delete the coupon?"',
    discard: {
      title: 'Unsaved Changes',
      content: 'You are about to close an activity with unsaved changes. If you do this, the changes will be lost. Are you sure you want to continue?',
      cancel: 'Cancel',
      ok: 'Discard Changes',
    },
  },
  update: {
    title: 'System Upgrade Notification',
    content: [
      'The current system version has been updated.',
      'Please save your progress and hard refresh the page.',
    ],
  },
  globalError: `An error has occurred. Please contact the administrator.
i2message_support{'@'}i2max.co.kr`,
};
